import { Pipe, PipeTransform } from '@angular/core';
import { UrlHelper } from '@helpers';

/**
 * Transform a value into URL
 */
@Pipe({
    name: 'url'
})
export class UrlPipe implements PipeTransform {

    transform(value: string): string {
        if (value) {
            const splitter = value.split(/(\s|<br>)/gm);
            const newValue = [];
            const index = splitter.findIndex(data => data.includes('data-options="no-url"'));
            for (const item of splitter) {
                if (UrlHelper.test(item) && index === -1) {
                    const data = '<a class="post__text__link text-primary-600 w-full truncate inline-block" href="' + item + '" target="_blank">' + item + '</a>';
                    newValue.push(data);
                } else {
                    newValue.push(item);
                }
            }

            return newValue.join(' ');
        }
        return value;
    }
}
